<template>
  <div>
    <label v-if="label != null" class="input-label">
      {{ label }}
    </label>
    <Slider v-model="newValue" 
            :min="min" 
            :max="max" 
            :step="step" 
            @change="$emit('updated', $event);" />
    <div class="text-center mt-1">
      <div class="clearfix"></div>
      <span class="float-right small text-muted">{{ maxLabel }}</span>
      <span class="float-left small text-muted">{{ minLabel }}</span>
    </div>
    <div class="clearfix"></div>
  </div>
</template>

<script>
import Slider from 'primevue/slider'

export default {
  name: "GoalSlider",
  
  components: {
    Slider
  },
  
  props: {
    value: Number,
    label: String,
    minLabel: {
      type: String,
      default: "Not so much"
    },
    maxLabel: {
      type: String,
      default: "Definitely"
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 100
    },
    step: {
      type: Number,
      default: 1
    }
  },
  
  mounted() {
    this.newValue = this.value;
  },

  watch: {
    value: {
      handler: function (val, oldVal)
      {
        this.newValue = val;
      }
    }
  },
  
  data() {
    return {
      newValue: null
    }
  }
}
</script>

<style scoped>
  .p-slider.p-slider-horizontal {
    height: 0.7rem;
  }
</style>